import { SlickTrackingModule } from "../helpers/SlickTrackingHelper";

export class SlickTrackingLoader {
     constructor() {
         this.init();
     }
     init() {
         const slickTracking = new SlickTrackingModule();    
     }
} 